import { useState } from 'react';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';
import Footer from '../../components/Footer';

const TesteNotificacao = () => {
    const { showNotification } = useNotification();
    const [description, setDescription] = useState('Esta é uma notificação de teste para o usuário ID 35');
    const [notificationLevel, setNotificationLevel] = useState(0);
    const [userId, setUserId] = useState(35);
    const [loading, setLoading] = useState(false);
    const [resultado, setResultado] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResultado(null);

        try {
            const payload = {
                description,
                notificationLevel,
                userId: parseInt(userId)
            };

            const response = await authFetch('notification', {
                method: 'POST',
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || 'Erro ao criar notificação');
            }

            const data = await response.json();
            setResultado({
                success: true,
                data: data,
                message: 'Notificação criada com sucesso!'
            });
            showNotification("success", "Notificação criada com sucesso!");
        } catch (error) {
            console.error(error);
            setResultado({
                success: false,
                error: error.message,
                message: 'Erro ao criar notificação'
            });
            showNotification("danger", "Erro ao criar notificação");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="content">
            <div className="card">
                <div className="card-body p-3">
                    <h3 className="font-weight-bolder mb-4">Teste de Notificação</h3>
                    <p className="text-muted mb-4">
                        Esta página permite criar uma notificação de teste para um usuário específico.
                        A notificação aparecerá no sino do usuário se o backend estiver configurado corretamente.
                    </p>

                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            <div className="col-md-12">
                                <label className="form-label">ID do Usuário</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={userId}
                                    onChange={(e) => setUserId(e.target.value)}
                                    required
                                    min="1"
                                />
                                <small className="form-text text-muted">
                                    ID do usuário que receberá a notificação
                                </small>
                            </div>

                            <div className="col-md-12">
                                <label className="form-label">Descrição da Notificação</label>
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    required
                                    placeholder="Digite a descrição da notificação..."
                                />
                            </div>

                            <div className="col-md-12">
                                <label className="form-label">Nível da Notificação</label>
                                <select
                                    className="form-select"
                                    value={notificationLevel}
                                    onChange={(e) => setNotificationLevel(parseInt(e.target.value))}
                                >
                                    <option value={0}>Normal</option>
                                    <option value={1}>Importante</option>
                                </select>
                                <small className="form-text text-muted">
                                    Notificações importantes aparecem destacadas
                                </small>
                            </div>

                            <div className="col-md-12">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Criando...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-bell me-2"></i>
                                            Criar Notificação
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>

                    {resultado && (
                        <div className={`mt-4 p-3 rounded ${resultado.success ? 'bg-light border border-success' : 'bg-light border border-danger'}`}>
                            <h5 className={resultado.success ? 'text-success' : 'text-danger'}>
                                {resultado.success ? '✓ Sucesso' : '✗ Erro'}
                            </h5>
                            <p className="mb-2">{resultado.message}</p>
                            {resultado.success && resultado.data && (
                                <div className="mt-3">
                                    <h6>Dados da Notificação Criada:</h6>
                                    <pre className="bg-white p-2 rounded border" style={{ fontSize: '0.9rem', maxHeight: '300px', overflow: 'auto' }}>
                                        {JSON.stringify(resultado.data, null, 2)}
                                    </pre>
                                </div>
                            )}
                            {!resultado.success && resultado.error && (
                                <div className="mt-3">
                                    <h6>Detalhes do Erro:</h6>
                                    <pre className="bg-white p-2 rounded border text-danger" style={{ fontSize: '0.9rem', maxHeight: '300px', overflow: 'auto' }}>
                                        {resultado.error}
                                    </pre>
                                </div>
                            )}
                        </div>
                    )}

                    <div className="mt-4 p-3 bg-info bg-opacity-10 rounded">
                        <h6 className="text-info">ℹ️ Informações Importantes:</h6>
                        <ul className="mb-0 small">
                            <li>O backend precisa ter o endpoint <code>POST /notification</code> implementado</li>
                            <li>O payload deve aceitar: <code>description</code>, <code>notificationLevel</code> e <code>userId</code></li>
                            <li>A notificação deve ser criada com <code>viewed: false</code> para aparecer no sino</li>
                            <li>O endpoint <code>GET /notification/user</code> deve retornar as notificações do usuário logado</li>
                            <li>Após criar, a notificação aparecerá no sino do usuário ID {userId} quando ele fizer login</li>
                        </ul>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default TesteNotificacao;

